import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Image.module.scss'

const Image = ({ image, alt, isSlim }) => (
  <img
    src={image}
    alt={alt}
    className={classnames(styles.image, isSlim && styles.slim)}
  />
)

Image.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  isSlim: PropTypes.bool,
}

export default Image
